import { convertToJSON } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { isProsemirrorState } from '../../../prosemirror/protected/operators';
export const getRawContentFromEditorState = editorState => {
  if (!editorState || !isProsemirrorState(editorState)) {
    return null;
  }
  return convertToJSON(editorState);
};